import React from 'react'

import useField, { IUseFieldOption } from '../useField'

interface ICustomValidator extends IUseFieldOption {
  name?: string
  children?: React.ReactNode
}
const CustomValidator = (
  props: ICustomValidator,
): React.ReactElement | null => {
  const { children, name = '', ...rest } = props

  const {
    meta: { valid, touched, error, value },
  } = useField(name, {
    ...rest,
    raw: true,
    subscription: { value: true, valid: true, touched: true, error: true },
  })

  if (valid || !touched) {
    return null
  }

  return React.cloneElement(children as React.ReactElement, {
    error,
    name,
    value,
  })
}

export default CustomValidator
